import React from 'react';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { Alert } from '@americanexpress/dls-react';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';

// stylesheets and icons
import styles from './InlineError.module.scss';
import Selectors from 'src/utils/selectors';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';

export interface InlineErrorProps {
    text: string;
    anchorText?: string;
    className?: string;
    onClick?: (e?: any) => void;
    href?: string;
}

export default function InlineError({
    text,
    anchorText,
    className = '',
    onClick,
    href
}: InlineErrorProps): JSX.Element {
    {
        const action: JSX.Element = onClick && anchorText && (
            <Anchor
                typographyProps={{
                    variant: TypographyVariants.LINK
                }}
                onClick={onClick}
                data-cy={Selectors.General.INLINE_ERROR_RETRY}
                href={href}
            >
                {anchorText}
            </Anchor>
        );

        return (
            <Alert className={className} data-cy={Selectors.General.INLINE_ERROR}>
                <span className={`${styles.errorText} ${DlsTypographyVariants.BODY_1}`}>{text}</span>
                {action}
            </Alert>
        );
    }
}
